module.exports = __webpack_public_path__ + "img/Dantam Hair 20.62c4a49b.jpg";